<template>
  <div>
    <MobileMenu v-if="$vuetify.breakpoint.mobile"/>
    <v-row no-gutters>
      <v-col cols="12">
        <BanersRow/>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <slot name="default"></slot>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BanersRow from '@/components/Partials/ShopBody/BanersRow.vue';
import MobileMenu from '@/components/Partials/TopBar/MobileMenu.vue';

export default {
  name: 'PageViewContainer',
  components: { MobileMenu, BanersRow },
};
</script>

<style scoped>

</style>
